import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import iconButtonStyles from './IconButton2.js';
import '../Tooltip/index.js';
import Tooltip from '../Tooltip/Tooltip.js';

const sizePropInIconErrorMessage = 'Warning: The `Icon` prop `size` is invalid when used as a child of `IconButton`.';
const IconButton = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    disabled = false,
    'aria-disabled': ariaDisabled = disabled,
    className = '',
    type = 'button',
    tooltipContent,
    tooltipPlacement,
    isTooltipADescription = false,
    onClick,
    onKeyDown,
    ...rest
  } = _ref;
  const classes = classNames(className, iconButtonStyles.button, {
    [iconButtonStyles.disabled]: disabled
  });
  if (children.props.size) {
    // eslint-disable-next-line no-console
    console.error(sizePropInIconErrorMessage);
  }
  const iconButtonComponent =
  /*#__PURE__*/
  /* eslint-disable react/button-has-type */
  React__default.createElement("button", _extends({}, rest, {
    type: type,
    className: classes,
    "aria-disabled": ariaDisabled,
    ref: ref,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React__default.cloneElement(children, {
    size: 'medium',
    'aria-hidden': true
  }))
  /* eslint-enable react/button-has-type */;
  if (tooltipContent) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      content: tooltipContent,
      placement: tooltipPlacement,
      delayMs: 500,
      "aria-hidden": isTooltipADescription ? undefined : true
    }, iconButtonComponent);
  }
  return iconButtonComponent;
});
var IconButton$1 = IconButton;

export { IconButton$1 as default };
